import { render } from "./CleanWrapper.vue?vue&type=template&id=6961e7f6"
import script from "./CleanWrapper.vue?vue&type=script&lang=js"
export * from "./CleanWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__